import { DEEP_LINK_APP, DEEP_LINK_APP_PROPOSAL } from '@constants';

export type MessageType = 'journey' | 'proposal';

export function getTextToContactTruckerWhatsApp({
  truckerName,
  companyName,
  userName,
  type,
  id,
}: {
  truckerName: string;
  companyName: string;
  userName: string;
  id: string;
  type: MessageType;
}) {
  const message: { [key in MessageType]: string } = {
    journey: `Olá ${truckerName}!

Aqui é o ${userName} da empresa ${companyName}, precisamos de mais informações da viagem.

Para acessar a viagem é só clicar no link:
${DEEP_LINK_APP}/journey_details/${id}

Aguardamos seu retorno!

Obrigado`,
    proposal: `Olá ${truckerName}!

Aqui é o ${userName} da empresa ${companyName} te enviamos uma proposta de viagem e estamos aguardando sua confirmação.

Para confirmar a viagem é só clicar no link:
${DEEP_LINK_APP_PROPOSAL}

Aguardamos sua confirmação.

Obrigado`,
  };

  return encodeURI(message[type]);
}

export function whatsappTalk(phone: string, text: string) {
  window.open(
    `https://api.whatsapp.com/send?phone=${phone}&text=${text}`,
    '_blank',
  );
}
